import axios from 'axios';

export default {
  // Master Data Region
  getRegions(params = {}) {
    return axios.get('/v1/sshcp/region', { params });
  },
  getRegionsMapping(params = {}) {
    return axios.get('/v1/sshcp/region/mapping', { params });
  },
  createRegionMapping(data) {
    return axios.post('/v1/sshcp/region/mapping', data);
  },
  updateRegionMapping(id, data) {
    return axios.put(`/v1/sshcp/region/mapping/${id}`, data);
  },

  // Master Data District
  getDistricts(params = {}) {
    return axios.get('/v1/sshcp/district', { params });
  },
  getDistrictsMapping(params = {}) {
    return axios.get('/v1/sshcp/district/mapping', { params });
  },
  getDistrictByRegion(params = {}) {
    return axios.get('/v1/sshcp/district/mapping/by-region/', { params });
  },
  createDistrictMapping(data) {
    return axios.post('/v1/sshcp/district/mapping', data);
  },
  updateDistrictMapping(id, data) {
    return axios.put(`/v1/sshcp/district/mapping/${id}`, data);
  },

  // Master Data Group
  getGroup(params = {}) {
    return axios.get('/v1/sshcp/group', { params });
  },
  createGroup(data) {
    return axios.post('/v1/sshcp/group', data);
  },
  updateGroup(id, data) {
    return axios.put(`/v1/sshcp/group/${id}`, data);
  },

  // Master Data Vendor
  getVendor(params = {}) {
    return axios.get('/v1/sshcp/vendor', { params });
  },
  createVendor(data) {
    return axios.post('/v1/sshcp/vendor', data);
  },
  updateVendor(id, data) {
    return axios.put(`/v1/sshcp/vendor/${id}`, data);
  },

  // Master Data Activities
  getMasterActivities(params = {}) {
    return axios.get('/v1/sshcp/activities', { params });
  },
  createActivities(data) {
    return axios.post('/v1/sshcp/activities', data);
  },
  updateActivities(id, data) {
    return axios.put(`/v1/sshcp/activities/${id}`, data);
  },

  // Budget Mapping
  getPONumber(params = {}) {
    return axios.get('/v1/sshcp/budget/mapping/list-po', { params });
  },
  getBudgetMapping(params = {}) {
    return axios.get('/v1/sshcp/budget/mapping', { params });
  },
  getAmountPO(poNumber) {
    return axios.get(`/v1/sshcp/budget/mapping/amount-po/${poNumber}`);
  },
  createBudgetMapping(data) {
    return axios.post('/v1/sshcp/budget/mapping', data);
  },
  updateBudgetMapping(id, data) {
    return axios.put(`/v1/sshcp/budget/mapping/${id}`, data);
  },

  // User Mapping
  getUserMapping(params = {}) {
    return axios.get('/v1/sshcp/user/mapping', { params });
  },
  getUserSSHCP(params = {}) {
    return axios.get('/v1/sshcp/user/mapping/list-users', { params });
  },
  getDetailUserMapping(id) {
    return axios.get(`/v1/sshcp/user/mapping/detail/${id}`);
  },
  createUserMapping(data) {
    return axios.post('/v1/sshcp/user/mapping', data);
  },
  updateUserMapping(id, data) {
    return axios.put(`/v1/sshcp/user/mapping/${id}`, data);
  },
  importUser(data) {
    return axios.post('/v1/sshcp/user/mapping/upload', data);
  },

  // Approval Mapping
  getApprovalMapping(params = {}) {
    return axios.get('v1/sshcp/config-approval', { params });
  },
  getUserByGroup(params = {}) {
    return axios.get('v1/sshcp/config-approval/user', { params });
  },
  getDetailApprovalMapping(id) {
    return axios.get(`/v1/sshcp/config-approval/${id}`);
  },
  createApprovalMapping(data) {
    return axios.post('/v1/sshcp/config-approval', data);
  },
  importApproval(data, params) {
    return axios.post('/v1/sshcp/config-approval/upload-mapping', data, {
      params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Form Request
  getActivities(params = {}) {
    return axios.get('/v1/sshcp/activity', { params });
  },
  getDistrictManager(params = {}) {
    return axios.get('/v1/sshcp/form-request/district-manager', { params });
  },
  getIObyPO(params = {}) {
    return axios.get('/v1/sshcp/form-request/po/io-number', { params });
  },
  getGLAccountbyIO(params = {}) {
    return axios.get('/v1/sshcp/form-request/io/taxonomy', { params });
  },
  getFormRequests(params = {}) {
    return axios.get('/v1/sshcp/form-request', { params });
  },
  getFormRequestDetail(id) {
    return axios.get(`/v1/sshcp/form-request/detail/${id}`);
  },
  saveAsDraft(data) {
    return axios.post('/v1/sshcp/form-request', data);
  },
  updateFormRequest(data) {
    return axios.post('/v1/sshcp/form-request/edit', data);
  },
  submitFormRequest(data) {
    return axios.post('/v1/sshcp/form-request/submit', data);
  },
  getProgressTracking(id) {
    return axios.get(`/v1/sshcp/form-request/progress-tracking/${id}`);
  },
  uploadSuppDocs(data) {
    return axios.post('/v1/sshcp/form-request/support-docs/upload', data);
  },
  getSummaryDetail(id) {
    return axios.get(`/v1/sshcp/form-request/detail-approve/${id}`);
  },
  downloadSuppDocs(id) {
    return axios.get(`/v1/sshcp/form-request/download/support-doc/${id}`);
  },
  approveRequest(data) {
    return axios.post('/v1/sshcp/form-request/approve', data);
  },
  rejectRequest(data) {
    return axios.post('/v1/sshcp/form-request/reject', data);
  },
  getTotalBudgetPO(params = {}) {
    return axios.get('/v1/sshcp/form-request/total-amount', { params });
  },
  getRequestLogs(params = {}) {
    return axios.get('/v1/sshcp/form-request/log', { params });
  },

  // RE ROUTE REQUEST
  getUserApprover(params = {}) {
    return axios.get('/v1/sshcp/user/mapping/user-approver', { params });
  },
  getRequestApproval(id) {
    return axios.get(`/v1/sshcp/config-approval/get-all-approval/${id}`);
  },
  requestReRoute(data) {
    return axios.post('/v1/sshcp/config-approval/reroute', data);
  },

  // AFTER B-RIGHT
  submitPrevalNumber(data) {
    return axios.post('/v1/sshcp/form-request/submit-preval', data);
  },
  detailPrevalNumber(id) {
    return axios.get(`/v1/sshcp/form-request/after-b-right/detail/${id}`);
  },
  approvePreval(data) {
    return axios.post('/v1/sshcp/form-request/after-b-right/approve', data);
  },
  rejectPreval(data) {
    return axios.post('/v1/sshcp/form-request/after-b-right/reject', data);
  },

  // MY PENDING APPROVAL
  getApprovalBeforeBright(params = {}) {
    return axios.get('/v1/sshcp/form-request/list-pending-approval', {
      params
    });
  },
  getApprovalAfterBright(params = {}) {
    return axios.get('/v1/sshcp/form-request/list-pending-after-b-right', {
      params
    });
  },

  // DASHBOARD
  getDashboard(params = {}) {
    return axios.get('/v1/sshcp/dashboard', { params });
  },
  getBudgetChart(params = {}) {
    return axios.get('/v1/sshcp/dashboard/budget-pie', { params });
  }
};
